import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SsoComponent } from './sso.component';

const routes: Routes = [
  { path: 'sso', component: SsoComponent }
]

@NgModule({
  declarations: [
    SsoComponent
  ],
  imports: [
    RouterModule.forChild(routes)
  ]
})
export class SsoModule { }
